export enum RouteType {
  Auth = 'Auth',
  NoAuth = 'NoAuth',
  Public = 'Public',
}
